import styles from "../assets/styles/components/ErrorPopup.module.scss";

import { IoCloseOutline } from "react-icons/io5";
interface Props {
  text: string;
  setText: (value: string) => void;
  onClose?: () => void;
}

export const ErrorPopup: React.FC<Props> = (props) => {
  return (
    <div
      className={styles.modal}
      onClick={() => {
        props.setText("");
        props.onClose?.();
      }}
    >
      <div className={styles.popUp}>
        <div className={styles.header}>
          <IoCloseOutline className={styles.icon} />
        </div>
        <div className={styles.text}>{props.text}</div>
      </div>
    </div>
  );
};
